"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_BUTTON_CLASS_MAP = exports.HEADER_CHILD_CLASS_MAP = void 0;
var HEADER_CHILD_CLASS_MAP = exports.HEADER_CHILD_CLASS_MAP = {
  headerDark: 'btn-dropdown-for-app-header',
  headerLight: 'btn-dropdown-for-app-header-light'
};
var ICON_BUTTON_CLASS_MAP = exports.ICON_BUTTON_CLASS_MAP = {
  headerDark: 'icon-btn-for-app-header',
  headerLight: 'icon-btn-for-app-header-light'
};